import { useRouter } from 'next/router';

const cleanUrlPath = (path: string) => path.trim().toLowerCase();
export const isPathMatching = (currentPath: string, matchList?: string): boolean => {
  if (!currentPath || !matchList) return false;

  const pathsMatchList = matchList.split(/\r?\n/).map((path) => cleanUrlPath(path));
  return pathsMatchList.some((path) => {
    if (!path) return false;

    if (path.endsWith('*')) {
      const basePath = path.slice(0, -1); // Remove the wildcard character
      return currentPath.startsWith(basePath);
    }

    return currentPath === path;
  });
};

export const usePathMatch = () => {
  const router = useRouter();
  const currentPath = router.asPath.split('?')[0].toLowerCase();

  const isCurrentPathMatched = (matchList?: string): boolean => {
    return isPathMatching(currentPath, matchList);
  };

  const matchRegex = (regex: RegExp) => {
    return currentPath.match(regex);
  };

  return { isCurrentPathMatched, matchRegex };
};
